package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.data.VerseEntity
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.utils.MyStringUtils
import com.eladfinish.bible.contest.utils.RegexUtils
import kotlinx.coroutines.Dispatchers

class SortVersesSingleChapterUseCase(
    private val assetReader: AssetReader,
    private val buildVerseEntitiesFromChapterUseCase: BuildVerseEntitiesFromChapterUseCase,
) {

    suspend operator fun invoke(
        bookNumber: Int,
        chapterNumber: Int,
    ): MutableList<VerseEntity> {
        val verseEntities = mutableListOf<VerseEntity>()
        val bookNameEnglish = BooksRepository.bookNamesEnglish[bookNumber - 1]
        val bookNameHebrew = BooksRepository.bookNamesHebrew[bookNumber - 1]

        val paddedNum = ChaptersRepository.padNumber(bookNameEnglish, chapterNumber)
        val filename = ChaptersRepository.getFileFormat(
            number = bookNumber, bookName = bookNameEnglish, chapter = paddedNum
        )
        val chapterContent = assetReader.readFile(fileName = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filename)

        val onlyContent = RegexUtils.getOnlyContent(chapterContent)
        val isFromSifreyEmet = MyStringUtils.isFromSifreyEmet(bookNameHebrew)
        val verseEntitiesOfChapter = buildVerseEntitiesFromChapterUseCase(
            coroutineContext = Dispatchers.Default,
            bookNumber = bookNumber,
            chapterNumber = chapterNumber,
            chapterContent = onlyContent,
            isFromSifreyEmet = isFromSifreyEmet,
        )
        verseEntities.addAll(verseEntitiesOfChapter)
        return verseEntities
    }

}
